import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import './style.css'
import { Button } from '../../../../components/button'
import { ResourceData } from './resources.data'
import { TableHeader } from '../../../../components/tableheader'
import { TableData } from '../../../../components/tabledata'

import { MultiSelect } from "react-multi-select-component"


const options = [
  { label: "Create", value: "Resources",},
  { label: "Edit", value: "category", },
  { label: "Delete", value: "tags", },
  
];


const Settings = () => {
  const [selectResource, setSelectResource] = useState(false);
  const [selected, setSelected] = useState([]);
  const [diffSelect, setdiffSelect] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const [addResource, setAddResource] = useState(false)

  const [roleName, setRoleName] = useState()
  const [roleDescription, setRoleDescription] = useState()
  const [usersRolesState, setUsersRolesState] = useState(ResourceData)

  const [updateUIWithout, setUpdateUIWithout] = useState(''); //Update UI after deleting
  const [canEdit, setCanEdit] = useState('') //Edit resourceCategory state

  const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
        setToggleState(index);
    }

    // handlers
    const onRoleName = (e) => {
      setRoleName(e.target.value)
    }

    const onRoleDescription = (e) => {
      setRoleDescription(e.target.value)
    }

    const handleAddResource = (e) => {
      if(canEdit){
        setCanEdit('')
        setAddResource(false)
        setRoleName('')
        setRoleDescription('')
       } else {
        setAddResource(!addResource)
       }

    }

     //updateUI without
    useEffect(()=> {
      setUsersRolesState([...usersRolesState.filter((role) => role.id !== updateUIWithout)])
    }, [updateUIWithout])

    const handleOnChange = () => {
      const userRolesData = {
        roleName,
        roleDescription
      }
      if(canEdit){
        // dispatch(editUserRole({...userRolesData, userRoleId: canEdit}))
        const indexOfEdited = usersRolesState.indexOf(usersRolesState.find((role) => role.id === canEdit))

        // const editedCategory = resourceCategoriesState.splice(indexOfEdited, 1)

        //Replace old edited category with updated
        usersRolesState.splice(indexOfEdited, 1, userRolesData)

        setUsersRolesState(usersRolesState)
        // console.log(resourceCategoriesState)
        // setResourceCategoriesState()

        setCanEdit('')


      } else {
        // dispatch(register(userData))
      }
      setIsChecked(!isChecked);
    };

    //canEdit state watcher
  useEffect(()=> {

      if(canEdit){
        setAddResource(true)

        const roleToEdit = usersRolesState.filter((role) => role.id === canEdit)[0]

        setRoleName(roleToEdit['resourceTitle'])
        setRoleDescription(roleToEdit['description'])
      }

  }, [canEdit])

  
  return (
    <Container>
        
      <PageHeader>
              <h2>Roles</h2>
              
              <div className='search_bar'>
                {/* <input type="text" name='collectionSearch' id='collectionSearch'  placeholder='Search items' /> */}

                <div>
                  <Button bgColor={'#2A870E'} text={' Associate role'} noIcon reverse />
                </div>
                <div onClick={handleAddResource} >
                <Button filled bgColor={'#2A870E'} text={canEdit || addResource ? 'Cancel' : ' + Add'} noIcon reverse />
                </div>
                
              </div>
            </PageHeader>

      {addResource ?
            <AddResource>

              <form> 

              <MainForm>
                  <div>
                    <label htmlFor="roleName">Role Name</label>
                    <input type="text" name='roleName' id='roleName' placeholder='Enter Role Name' value={roleName} onChange={onRoleName} />
                  </div>

              

                  <div>
                    <label htmlFor="roleDescription">Role Description</label>
                    <textarea type="text" name='roleDescription' id='roleDescription' placeholder='Describe the role' value={roleDescription} onChange={onRoleDescription} />
                  </div>  
              

              <br />

              
              {/* <select name="" id="">
                <li>Hello</li>
                <option value="" onClick={ () => toggleTab()}>Choose permission</option>
                <option value="resources" onClick={ () => console.log('dhsdhs')}>Resources permissions</option>
                <option value="faq" onClick={ () => toggleTab(2)}>FAQ permissions</option>
                <option value="newspaper" onClick={ () => toggleTab(3)}>Newspaper permissions</option>
                <option value="users" onClick={ () => toggleTab(4)}>Users permissions</option>

              </select>

              <br />

              {toggleState === 1

              ?
              <>
                <MultiSelect
                options={options}
                value={selected}
                onChange={setSelected}
                labelledBy="Select"
              />

</>
             :!toggleState === 2
              ?<Button text={'djsddddddddddddddddd'} />
           :toggleState === 3
              ?<MultiSelect
              options={options}
              value={selected}
              onChange={setSelected}
              labelledBy="Select"
            />
            :toggleState === 4
            ?<MultiSelect
            options={options}
            value={selected}
            onChange={setSelected}
            labelledBy="Select"
            />:null

              }

               */}

              
              </MainForm>

              <div className='publish'>
                <Button filled bgColor={'#2A870E'} text={'Publish'} noIcon reverse />
              </div>
              
              </form>
              
            </AddResource>
      :
      null
      }

            <section>
              <TableHeader newpaperName={'Role name'} authorName={'Role description'} />
              

      {
                    usersRolesState.map((resources) => {
                      return (
                        <TableData resourceTitle={resources.resourceTitle.substring(0, 50)} 
                        description={resources.description.substring(0, 50)}
                        key={resources.id}
                        setUpdateUIWithout={setUpdateUIWithout} setCanEdit={setCanEdit}
                        roleId={resources.id}
                        
                        />
                        
                        
                      )
                    })
              
      }      

      </section>

            

            
    </Container>
  )
}

const Container = styled.section`
  padding-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
`

const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > div{
    display: flex;
    height: 40px;

    & > div{
      display: flex;
    }

    & > input{
      /* outline: none; */
      padding: 1rem;
      background-color: inherit;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
    }

    & button{
      padding: 1rem;
      margin-left: 1rem;
      /* width: 50px; */
    }
  }
`

const AddResource = styled.div`
  padding: 0px 25px 0;
  border: 1px solid #D0D5DD;
  margin-top: 30px;
  margin-bottom: 30px;

  & form {


    & > :last-child{
      margin-top: 3rem;
      border-top: 1px solid #D0D5DD;
      align-self: flex-end;
      padding: 1rem 0;
    }
    & button{
      padding: 1rem;
      margin-left: 1rem;
      align-self: flex-end;
      /* margin-top: 3rem; */

      /* border: 1px solid red; */

      /* width: 50px; */
    }
  }
`



const MainForm = styled.div`

    & select{
        background-color: inherit;
        width: 100%;
        height: 44px;
        padding: 1rem;
        border-radius: 4px;
        border: 1px solid #D0D5DD;
      }


  & > div{

    display: flex;
    flex-direction: column;
    width: 100%;


    & > input{
      background-color: inherit;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      width: 100%;
      
  }

    & > label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 25px;
      margin-bottom: 0.8rem;
      /* color: #667085; */
    }

    & > textarea{
      height: 10rem;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      background-color: #fff;

    }    
  }
`

const DividedInput = styled.section`
 

  & > div{
    display: flex;
    flex-direction: column;
    

    

  &  label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
      margin-bottom: 5px;

    }

  }
`

const CustomSelect = styled.div`
      padding: 1rem;
      background-color: inherit;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      height: 44px;

      &:focus, &:hover, &:active {
        border: 1px solid #136cfc;

      }
`;

export {Settings}